import { Telefono } from "../components/telefono/telefono.component";

export class TipoUsuario {
  constructor(
    public id?: number,
    public descripcion?: string
  ) { }
}

export class PuestoUsuario {
  constructor(
    public id?: number,
    public descripcion?: string
  ) { }
}

export class Usuario {
  constructor(
    public IdUsuario?: number,
    public usuario?: string,
    public email?: string,
    public tipoUsuario: TipoUsuario = {},
    public contrasena?: string,
    public nombre?: string,
    public apellido?: string,
    public telefono: Telefono = new Telefono('', '', ''),
    public estado?: number,
    public puesto?: PuestoUsuario,
    public editable: boolean = false,
    public eliminable: boolean = false
  ) { }
}
export class usuarios {
  constructor(
    public usuario_id?: number,
  ) { }
}
